export const formButtonArrows = () => {
    document.addEventListener('DOMContentLoaded', () => {
        const styleSubmitButtonsInForm = (formContainer: HTMLElement) => {
            const submitInputs = formContainer.querySelectorAll<HTMLInputElement>('input[type="submit"].btn.primary, input[type="submit"].btn.next, input[type="submit"].btn.prev');

            submitInputs.forEach(input => {
                // Check if an arrow already exists to prevent duplicates
                if (input.nextElementSibling && input.nextElementSibling.classList.contains('input-submit-arrow')) {
                    return;
                }

                const arrowSpan = document.createElement('span');
                arrowSpan.classList.add('input-submit-arrow');
                // Insert the arrow span immediately after the input element
                input.parentNode?.insertBefore(arrowSpan, input.nextSibling);
            });
        };

        const formBlocks = document.querySelectorAll<HTMLElement>('.form-block');

        formBlocks.forEach(formBlock => {
            // Initial styling
            styleSubmitButtonsInForm(formBlock);

            // Observe for changes within each form block (e.g., for multi-step forms)
            const observer = new MutationObserver(mutations => {
                mutations.forEach(mutation => {
                    if (mutation.type === 'childList' || mutation.type === 'attributes') {
                        styleSubmitButtonsInForm(formBlock);
                    }
                });
            });

            observer.observe(formBlock, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        });
    });
}